module.exports = __webpack_public_path__ + "img/+-gray.0058aa7c.svg";